<script setup>
import { computed, ref } from 'vue'
import { useAsyncState, watchImmediate } from '@vueuse/core'
import axios from 'axios'
import VideoTranscriptRow from './video-transcript-row.vue'
import { useVideoShow } from '../use-video-show'
import { convertWebvttToData } from './utils'

const props = defineProps({
  video: {
    required: true
  }
})

const { playerRef } = useVideoShow()
const playerCurrentTime = ref(0)

const { state: videoSubtitleContent } = useAsyncState(async () => {
  const res = await axios.get(props.video.subtitle_url)
  return res.data
}, '', {
  immediate: true
})

const subtitleRows = computed(() => convertWebvttToData(videoSubtitleContent.value))

watchImmediate(playerRef, player => {
  if (player) {
    playerCurrentTime.value = player.currentTime()

    player.on('timeupdate', () => {
      playerCurrentTime.value = player.currentTime()
    })
  }
})

</script>

<template>
  <div class="p-4">
    <video-transcript-row
      v-for="line in subtitleRows"
      :key="line.start"
      :transcript-row-data="line"
      :player-current-time="playerCurrentTime"
    />
  </div>
</template>
